export default __webpack_public_path__ + "static/media/404.21608b42.svg";